export default function() {
    const counterBlock = document.getElementById( 'theme-counter' );

    if ( ! counterBlock ) {
        return;
    }

    const deadline = new Date( counterBlock.getAttribute( 'data-deadline' ) );

    if ( isNaN( deadline ) ) {
        counterBlock.classList.add( 'd-none' );
        return;
    }

    const labels = [ 'Days', 'Hours', 'Min' ];
    const timerBoxes = counterBlock.querySelectorAll( '.timer-box' );

    timerBoxes.forEach( ( box, index ) => {
        box.innerHTML = `
            <span class="fs-5 fw-semibold text-black">00</span>
            <small>${ labels[ index ] }</small>
        `;
    } );

    function createFlipCard( valueElement, labelIndex ) {
        const timerBox = valueElement.closest( '.timer-box' );
        const currentValue = valueElement.textContent || '00';

        timerBox.innerHTML = `
            <div class="flip-card position-absolute top-0 start-0 w-100 h-100">
                <div class="flip-card-inner position-relative w-100 h-100 text-center d-flex flex-column justify-content-center align-items-center">
                    <div class="flip-card-front position-absolute w-100 h-100 d-flex flex-column justify-content-center align-items-center overflow-hidden">
                        <span class="fs-5 fw-semibold text-black">${ currentValue }</span>
                        <small class="mt-1">${ labels[ labelIndex ] }</small>
                    </div>
                    <div class="flip-card-back position-absolute w-100 h-100 d-flex flex-column justify-content-center align-items-center overflow-hidden">
                        <span class="fs-5 fw-semibold text-black"></span>
                        <small class="mt-1">${ labels[ labelIndex ] }</small>
                    </div>
                </div>
            </div>
        `;
    }

    function updateCounter() {
        const now = new Date();
        const difference = deadline - now;

        if ( difference <= 0 ) {
            counterBlock.classList.add( 'd-none' );
            clearInterval( timerId );
            return;
        }

        const days = Math.floor( difference / ( 1000 * 60 * 60 * 24 ) );
        const hours = Math.floor( ( difference / ( 1000 * 60 * 60 ) ) % 24 );
        const minutes = Math.floor( ( difference / 1000 / 60 ) % 60 );

        const values = [ days, hours, minutes ];

        timerBoxes.forEach( ( box, index ) => {
            const valueElement = box.querySelector( 'span' );
            const currentValue = parseInt( valueElement.textContent || '0' );
            const newValue = values[ index ];

            if ( currentValue !== newValue ) {
                createFlipCard( valueElement, index );
                const flipCard = box.querySelector( '.flip-card' );
                const backValue = flipCard.querySelector( '.flip-card-back span' );

                void flipCard.offsetWidth;
                flipCard.classList.add( 'flipping' );

                setTimeout( () => {
                    const paddedValue = newValue.toString().padStart( 2, '0' );
                    backValue.textContent = paddedValue;

                    setTimeout( () => {
                        flipCard.classList.remove( 'flipping' );
                        box.innerHTML = `
                            <span class="fs-5 fw-semibold text-black">${ paddedValue }</span>
                            <small>${ labels[ index ] }</small>
                        `;
                    }, 300 );
                }, 300 );
            }
        } );
    }

    const timerId = setInterval( updateCounter, 1000 );
    updateCounter();
}
